import React, { useState } from "react";
import styles from "./styles.module.scss";
import Banner from "@assets/img/sliderBanner.png";
import WelcomeSliderBtn from "@assets/icons/welcomeSliderBtn";

const Slider: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const length = 10;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  return (
    <div className={styles.slider}>
      <button className={styles.leftArrow} onClick={prevSlide}>
        <div className={styles.iconWrapper}>
          <WelcomeSliderBtn />
        </div>
      </button>
      <button className={styles.rightArrow} onClick={nextSlide}>
        <div className={styles.iconWrapper}>
          <WelcomeSliderBtn />
        </div>
      </button>
      {Array(length)
        .fill(true)
        .map((_, index) => {
          return (
            <div
              className={`${styles.slide} ${index === current ? styles.slideActive : ""}`}
              key={index}
            >
              {index === current && (
                <div className={styles.imgContainer}>
                  <img src={Banner} />
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default Slider;
